import core from "@/helpers/client";
const TechProductsService = {
  async headTechProductsAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts?no-cache=1`,
      params
    );
    return result;
  },
  async getTechProductsAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts?no-cache=1`,
      params
    );
    return result;
  },
  async getTechProductAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${id}?no-cache=1`
    );
    return result;
  },
  async createTechProductsAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts`,
      model
    );
    return result;
  },
  async updateTechProductsAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${id}`,
      model
    );
    return result;
  },
  async deleteTechProductsAsync(clientAppsId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${clientAppsId}/TechProducts/${id}`
    );
    return result;
  },
  async getTechProductParameterOptionsAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${id}/ParametorOptions?no-cache=1`
    );
    return result;
  }, 
  async applyTechProductClientApps(id,model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${id}/ClientApps`,
      model
    );
    return result;
  },
    async updateApplyTechProductClientApps(id,clientAppsId,model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${id}/ClientApps/${clientAppsId}`,
      model
    );
    return result;
  },
  async getTechProductClientAppsDetailAsync(techProductId,clientAppsId) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${techProductId}/ClientApps/${clientAppsId}`
    );
    return result;
  },
  async resetTokenTechProductClientApps(id,clientAppsId,model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${id}/ClientApps/${clientAppsId}/reset-token`,
      model
    );
    return result;
  },

  async getTechProductClientAppsToken(id, clientAppsId, client_apps_allow_service_id) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${id}/ClientApps/${clientAppsId}/token?client_apps_allow_service_id=${client_apps_allow_service_id}`,
      model
    );
    return result;
  },
  async getTechProductClientAppsAsync(techProductId,params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${techProductId}/ClientApps`,
      params
    );
    return result;
  },
  async getTechProductPermissionsAsync(techProductId,params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${techProductId}/Permissions`,
      params
    );
    return result;
  },
  async getTechProductClientAppsPermissionsAsync(techProductId,clientAppsId,params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${techProductId}/ClientApps/${clientAppsId}/Permissions`,
      params
    );
    return result;
  },
  async createServiceClientAppsPermissionAsync(techProductId,clientAppsId,model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${techProductId}/ClientApps/${clientAppsId}/Permissions`,
      model
    );
    return result;
  },
  async deleteServiceClientAppsPermissionAsync(techProductId, clientAppsId, params) {
    
    const result = await core.remove(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/TechProducts/${techProductId}/ClientApps/${clientAppsId}/Permissions?${params}`,
    );
    return result;
  },
  



};
export default TechProductsService;
